import { connect } from 'react-redux';
import { selectIsDesktop } from 'selectors/ui';
import Title from './Title';

const mapStateToProps = state => ({
  isDesktop: selectIsDesktop(state),
});

export default connect(mapStateToProps)(Title);
